/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstCenterSupplierUpdateBase } from './MstCenterSupplierUpdateBase';
import {
    MstCenterSupplierUpdateBaseFromJSON,
    MstCenterSupplierUpdateBaseFromJSONTyped,
    MstCenterSupplierUpdateBaseToJSON,
    MstCenterSupplierUpdateBaseToJSONTyped,
} from './MstCenterSupplierUpdateBase';

/**
 * 
 * @export
 * @interface MstCenterSupplierUpdate
 */
export interface MstCenterSupplierUpdate {
    /**
     * 
     * @type {Array<MstCenterSupplierUpdateBase>}
     * @memberof MstCenterSupplierUpdate
     */
    body: Array<MstCenterSupplierUpdateBase>;
}

/**
 * Check if a given object implements the MstCenterSupplierUpdate interface.
 */
export function instanceOfMstCenterSupplierUpdate(value: object): value is MstCenterSupplierUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstCenterSupplierUpdateFromJSON(json: any): MstCenterSupplierUpdate {
    return MstCenterSupplierUpdateFromJSONTyped(json, false);
}

export function MstCenterSupplierUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCenterSupplierUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstCenterSupplierUpdateBaseFromJSON)),
    };
}

export function MstCenterSupplierUpdateToJSON(json: any): MstCenterSupplierUpdate {
    return MstCenterSupplierUpdateToJSONTyped(json, false);
}

export function MstCenterSupplierUpdateToJSONTyped(value?: MstCenterSupplierUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstCenterSupplierUpdateBaseToJSON)),
    };
}

